import { render } from "./ZapiBannerOffline.vue?vue&type=template&id=71216fb1&scoped=true"
import script from "./ZapiBannerOffline.vue?vue&type=script&lang=js"
export * from "./ZapiBannerOffline.vue?vue&type=script&lang=js"

import "./ZapiBannerOffline.vue?vue&type=style&index=0&id=71216fb1&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71216fb1"]])

export default __exports__